<template lang="pug">
div
  desktop(v-if="$vuetify.breakpoint.mdAndUp", :menu="menu")
  mobile(v-else, :menu="menu")
</template>

<script>
import Desktop from "./Desktop/Index.vue";
import Mobile from "./Mobile";
import { menu } from "@/config.js";

export default {
  data: () => ({
    menu,
  }),
  created() {
    for (let { getDropdown } of menu) if (getDropdown) getDropdown(this);
  },
  components: {
    Desktop,
    Mobile,
  },
};
</script>

<style>
.logo {
  height: 100%;
  object-fit: contain;
  max-width: 280px;
}
.v-app-bar,
.v-toolbar,
.v-toolbar * {
  z-index: 99 !important;
}

@media screen and (min-width: 960.001px) {
  header .v-toolbar__content {
    display: block !important;
    padding: 0 !important;
  }
  .logo {
    width: 100%;
  }
}
</style>
